import React, {Component} from "react";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {Link} from "react-router-dom";
import {withNamespaces} from "react-i18next";
import NetworkDeviceForm from "./_forms/NetworkDeviceForm";

class NetworkDeviceCreatePage extends Component {

    render() {
        const { t } = this.props;
        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device' },
            { value: 'add_network_device', path: '#' },
        ];

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{t('add_network_device')}</h4>
                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            <Link to="/panel/network-device" className="btn btn-secondary float-right btn-create">
                                <i className="fas fa-undo"> </i> &nbsp; { t('back-to-list') }
                            </Link>
                        </div>
                    </div>
                    <div className="card-body">
                        {/*network device form components*/}
                        <NetworkDeviceForm/>
                    </div>
                </div>
            </div>
        )
    }
}
export default withNamespaces()(NetworkDeviceCreatePage);
